<template>
  <div class="block page16 f-r f-c">
    <PageHeader :title="moduleData['3_16_1_1']" :sub-title="moduleData['3_16_1_1_en']"/>
    <PageTips page-num="13"/>
    <div class="page16-body f-r j-b">
      <div class="page16-body-left">
        <TableNav width="900px" style="margin-bottom: 20px">
          <template v-slot:title>{{ moduleData["3_16_2_2"] }}</template>
          <template v-slot:subtitle> 总购物中心数量：{{catData1.count}} 个</template>
        </TableNav>
        <PTable :col-data="colData" :row-data="rowData1.slice(0,10)" style="height: 706px">
          <Empty text="当前区域暂无购物中心覆盖" v-if="!rowData1.length"/>
        </PTable>
      </div>
      <div class="page16-body-right f-c">
        <div class="page16-map" id="page16Map">
          <Empty text="当前区域暂无购物中心覆盖" v-if="!catData1.pois.length && !polygonData.length"/>
        </div>
        <div class="page16-map-tips">
          <div class="page-tips2" style="padding-bottom: 27px;margin: 23px 0 19px 0">>更多购物中心详情于APP「项目招商」中查看</div>
          数据来源：位置厂商数据，边界房产大数据
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import TableNav from "./components/TableNav";
import PTable from "./components/PTable";

import AMapLoader from "@amap/amap-jsapi-loader";
import { shallowRef } from "@vue/reactivity";

import { computed, defineComponent, onMounted, ref } from "vue";
import { mapAddCircle, mapAddPolygon, addMapCenter } from "@/utils/pdf";
import { useStore } from "vuex";
import { getBusPolygon, drawMapKeepAlive } from "@/api/apiv1";

import { getMapDelayByMarkerCount } from '@/utils'

export default defineComponent({
  components: {
    PageHeader,
    PageTips,
    TableNav,
    PTable,
  },
  props: {
      cityInfo: {
          type: Object,
          default: () => {
              return {};
          },
      },
      catData1: {
          type: Object,
          default: () => {
              return {
                  pois: []
              };
          },
      },
    moduleData: {
      type: Object,
      default: () => {
        return {

        };
      },
    },
  },
    setup(props) {
        const polygonData = ref([])
        const store = useStore()
        const colData = ref([
            { prop: "index", width: "67px", label: "序号" },
            { prop: "name", width: "300px", label: "项目名称" },
            { prop: "shopping_center_open_time", width: "170px", label: "开业时间" },
            // 新 shopping_center_commercial_area
            { prop: "shopping_center_commercial_area", width: "172px", label: "商业面积" },
            { prop: "distance", width: "100px", label: "距离", subLabel: 'km' },
        ]);
        const rowData1 = computed(() => {
            return (props.catData1.pois || []).map((el,index) => {
                let _index = index + 1
                return {
                    index: _index < 10 ? ('0' + _index) : _index,
                    ...el
                }
            })
        });
        let map = shallowRef(null);
        const addMaker = (amap, map, newData) => {
            let markerList = [];
            newData.forEach((v) => {
                let content = `<div style="width: 12px;height: 12px; border-radius: 50%;background: #1644FF;"></div>`
                let marker = new amap.Marker({
                    position: new amap.LngLat(
                        v.location.split(",")[0],
                        v.location.split(",")[1]
                    ),
                    content
                });
                markerList.push(marker);
            });
            map.add(markerList);
        };
        onMounted(async () => {
          // 获取围栏
          try {
            const BusPolygonData = await getBusPolygon(store.state.baseReport.module1)
            polygonData.value = BusPolygonData.data || []
          } catch (e) {
            console.log(e);
          }
          console.log('polygonData.value',polygonData.value);
          AMapLoader.load({
              key: "f0da9fb8263bb9b657e2257ec09c6df7", // 申请好的Web端开发者Key，首次调用 load 时必填
              version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
              plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
          }).then((AMap) => {
            map = new AMap.Map("page16Map", {
              WebGLParams: {
                  preserveDrawingBuffer:true
              },
              dragEnable: false,
              zoomEnable: false,
              zoom: store.getters.mapZoom, //初始化地图级别
              center: props.cityInfo.location.split(","), //初始化地图中心点位置
            });
            mapAddCircle(props.cityInfo, map)
            const Polygon = mapAddPolygon(polygonData.value)
            Polygon.forEach(el => {
              map.add(el.polygon);
            })
            addMaker(AMap, map, [
                ...props.catData1.pois,
            ]);
            addMapCenter(AMap, map, props.cityInfo.location)

            // 等待地图渲染
            const delay = getMapDelayByMarkerCount(props?.catData1?.pois?.length || 0)
            drawMapKeepAlive(delay).catch((e) => {})

            map.setFitView()
          })
          .catch((e) => {
              console.log(e);
          });
        });

        return {
            map,
            colData,
            rowData1,
          polygonData
        };
    },
});
</script>

<style lang="less">
.page16 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;
  .page16-body {
    flex-grow: 1;
    padding: 67px 20px 0 61px;
      .nav3 {
          font-size: 24px;
      }
    .page16-body-left {
      width: 900px;
    }
    .page16-body-right {
      width: 853px;
      .page16-map {
        width: 100%;
        height: 760px;
      }
      .page16-map-legend {
        flex-grow: 1;
        padding: 23px 0 23px 46px;
        .page16-map-legend-item {
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          margin-right: 76px;
        }
        .page16-map-legend-item:last-child {
          margin-right: 0;
        }
        .page16-map-legend-icon {
          width: 22px;
          height: 22px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-right: 12px;
        }
        .icon1 {
          background-image: url("~@/assets/机场.png");
        }
        .icon2 {
          background-image: url("~@/assets/火车站.png");
        }
        .icon3 {
          background-image: url("~@/assets/高铁站.png");
        }
        .page16-map-legend-point {
          width: 22px;
          height: 22px;
          margin-right: 12px;
          border-radius: 50%;
        }
        .point1 {
          background-color: #1644ff;
        }
        .point2 {
          background-color: #ff8116;
        }
      }
      .page16-map-tips {
        flex-shrink: 0;
        text-align: right;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9a9a9a;
        line-height: 28px;
      }
    }
  }
}
</style>
